var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',[_c('SiteMasthead',{attrs:{"title":"Properties","mini":"true"}}),_c('ContentRow',[_c('ContentContainer',[(_vm.listingFilter)?_c('Listings',{attrs:{"filter":_vm.listingFilter}}):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }